import { DemographicSetting } from "../models/demographic-setting";

export class DemographicsService {
    private static endpoint = '/apic/demographics';

    public getOptions = async (rootEngagementId: number): Promise<Array<DemographicSetting>> => {
        const response = await fetch(`${DemographicsService.endpoint}/${rootEngagementId}`, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'GET'
        });
        const body = await response.json() as any[];
        return body.map(DemographicSetting.fromJson);
    };

    public setOptions = async (options: Array<DemographicSetting>): Promise<void> => {
        await fetch(DemographicsService.endpoint, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'PATCH',
            body: JSON.stringify(options)
        });
    }
}